export default __webpack_public_path__ + "static/media/birthdayBackground.c009f72e.jpg";